import type { ReactNode } from "react";
import { Fragment } from "react";
import JobTitle from "../atom/job-title";
import Rank from "../atom/rank";
import Time from "../atom/time";
import Title from "../atom/title";

type Content2Props = {
  renderRank: ReactNode;
  renderTitle: ReactNode;
  renderTime: ReactNode;
};

export const Content2 = (props: Content2Props) => {
  const { renderRank, renderTime, renderTitle } = props;

  return (
    <Fragment>
      {renderRank}
      {renderTitle}
      {renderTime}
    </Fragment>
  );
};

Content2.Rank = Rank;
Content2.Title = Title;
Content2.JobTitle = JobTitle;
Content2.Time = Time;
